import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whyChooseShipAndStorageSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/track-your-shipping-page'

interface TrackYourShippingPageProps {}

const TrackYourShippingPage: React.FC<TrackYourShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
      w-[324px] h-[218px] 
      md-mn:w-[380px] md-mn:h-[286px] 
      lg:!w-[448px] lg:!h-[313px] 
      xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[290px] xl-min:!h-[50px] lg-mn:w-[240px] md-mn:w-[233px] w-[274px] h-[44px]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionContent}
        className={`
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3
          [&_article]:text-center
          [&_article_div]:w-full md-mn:[&_article]:px-0 
          [&_article]:px-6 
          [&_h3]:text-center 
          xl-min:[&_button]:!w-[263px]
          md-mn:[&_button]:w-[218px]
          [&_button]:w-[278px]
          `}
      />
      <WhyWeSection
        {...whyWeSectionContent}
        className='
          [&_article]:bg-transparent 
          [&>div>div:nth-of-type(2)]:xl-min:!grid-cols-4
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-2
      '
        sectionTitleClassName='xl-min:[&_p]:!w-[550px] md-mn:[&_p]:w-[440px] [&_p]:w-[90%]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...whyChooseShipAndStorageSectionContent}
        sectionTitleClassName='xl-min:[&_p]:!w-[550px] md-mn:[&_p]:w-[440px] [&_p]:w-[90%]'
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[350px] md-mn:h-[196px] w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            md-mn:[&>div>div:last-of-type>div]:!flex-row-reverse
            [&>div>div:last-of-type>div]:flex-col
            `}
        sectionTitleClassName='md-mn:[&_p]:w-[530px]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          md-mn:[&_h3]:w-full
          [&_h3]:w-[80%] 
          [&_h3]:mx-auto
          xl-min:[&_button]:!w-[242px]
          lg-mn:[&_button]:w-[236px]
          md-mn:[&_button]:w-[229px]
          [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default TrackYourShippingPage
